/** Lowercase hostname without leading www. */
function normalizeHost(hostname) {
  return (hostname || "").toLowerCase().replace(/^www\./, "");
}

/** Per-host API and image URLs. Add new deployments here without changing existing ones. */
const HOST_CONFIG = {
  localhost: {
    // base_url: "http://localhost:52476/api/",
    base_url: "https://api.fuelbook.pk/api/",
    images: "https://api.fuelbook.pk/images/",
  },
  "nd.petrol-pump.com": {
    // base_url: "http://localhost:52476/api/",
    base_url: "https://api.fuelbook.pk/api/",
    images: "https://api.fuelbook.pk/images/",
  },
  "app1.zakipetroleum.com": {
    base_url: "https://app1api.zakipetroleum.com/api/",
    images: "https://app1api.zakipetroleum.com/images/",
  },
};

/** Production default (app.fuelbook.pk and other existing hosts). */
const DEFAULT_CONFIG = {
  base_url: "https://api.fuelbook.pk/api/",
  images: "https://api.fuelbook.pk/images/",
};

/**
 * Resolve API URLs from the browser hostname.
 * Supports www.app1... and appN.zakipetroleum.com -> appNapi.zakipetroleum.com.
 */
function resolveHostConfig(hostname) {
  const host = normalizeHost(hostname);

  if (HOST_CONFIG[host]) {
    return HOST_CONFIG[host];
  }

  const zakiAppMatch = host.match(/^app(\d+)\.zakipetroleum\.com$/);
  if (zakiAppMatch) {
    const apiHost = `app${zakiAppMatch[1]}api.zakipetroleum.com`;
    return {
      base_url: `https://${apiHost}/api/`,
      images: `https://${apiHost}/images/`,
    };
  }

  const zakiApiMatch = host.match(/^app(\d+)api\.zakipetroleum\.com$/);
  if (zakiApiMatch) {
    return {
      base_url: `https://${host}/api/`,
      images: `https://${host}/images/`,
    };
  }

  return DEFAULT_CONFIG;
}

function getRuntimeConfig() {
  if (typeof window !== "undefined" && window.location?.hostname) {
    return resolveHostConfig(window.location.hostname);
  }
  return DEFAULT_CONFIG;
}

const config = {
  get base_url() {
    return getRuntimeConfig().base_url;
  },
  get images() {
    return getRuntimeConfig().images;
  },
  date_format: "DD MMM YYYY",
};

export { getRuntimeConfig, normalizeHost, resolveHostConfig };

if (typeof window !== "undefined") {
  window.__FUELBOOK_CONFIG__ = {
    get hostname() {
      return window.location.hostname;
    },
    get base_url() {
      return config.base_url;
    },
    get images() {
      return config.images;
    },
  };
}

export default config;
